import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import EmissionFactorsAdmin from './EmissionFactorsAdmin';

/**
 * Emisyon Faktörleri Admin Sayfası
 */
const EmissionFactorsAdminPage = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h3" color="primary" gutterBottom>
          ⚙️ Emisyon Faktörleri Yönetimi
        </Typography>
        <Typography variant="h6" color="textSecondary">
          Karbon ayak izi hesaplamalarında kullanılan emisyon faktörlerini yönetin
        </Typography>
      </Box>
      
      <EmissionFactorsAdmin 
        onFactorsUpdate={(factors) => {
          console.log('Emission factors updated:', factors);
          // Burada gerekirse global state güncellemesi yapılabilir
        }}
      />
    </Container>
  );
};

export default EmissionFactorsAdminPage;
